"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * AudioProfile defines quality settings of the audio input
 * device. Use the static methods to create presets optimized
 * for fullband speech and fullband music with a mono channel.
 */
var AudioProfile = /*#__PURE__*/function () {
  /**
   * Constructs an AudioProfile given an audio bitrate. If no
   * audio bitrate is supplied, then the default AudioProfile
   * is constructed. The default AudioProfile does not adjust
   * the browser's internal bitrate setting.
   */
  function AudioProfile() {
    var audioBitrateBps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    _classCallCheck(this, AudioProfile);
    this.audioBitrateBps = audioBitrateBps;
  }
  /**
   * Creates an AudioProfile optimized for fullband speech (40 kbit/s mono).
   */
  _createClass(AudioProfile, [{
    key: "isStereo",
    /**
     * Returns true if audio profile is set to stereo mode.
     */
    value: function isStereo() {
      return this.audioBitrateBps === 128000;
    }
  }], [{
    key: "fullbandSpeechMono",
    value: function fullbandSpeechMono() {
      return new AudioProfile(40000);
    }
    /**
     * Creates an AudioProfile optimized for fullband music (64 kbit/s mono).
     */
  }, {
    key: "fullbandMusicMono",
    value: function fullbandMusicMono() {
      return new AudioProfile(64000);
    }
    /**
     * Creates an AudioProfile optimized for fullband stereo music (128 kbit/s stereo).
     */
  }, {
    key: "fullbandMusicStereo",
    value: function fullbandMusicStereo() {
      return new AudioProfile(128000);
    }
  }]);
  return AudioProfile;
}();
exports.default = AudioProfile;